import { View, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";
import { useNavigation } from "@react-navigation/native";

const ReconListTile = ({ item, isHistory = false }) => {
  const navigation = useNavigation();
  const subTitle = ({ subtitle, value }) => {
    return (
      <View style={styles.captionValueContainer}>
        <Text variant="caption_2" style={styles.subtitle}>
          {subtitle}
        </Text>
        <Text variant="caption_2" style={styles.value}>
          {value || 0}
        </Text>
      </View>
    );
  };

  return (
    <TouchableOpacity
      testID="recon-list-tile"
      style={styles.container}
      activeOpacity={0.8}
      onPress={() => {
        if (isHistory) {
          navigation.navigate("ReconHistoryDetails", {
            item,
          });
        } else {
          navigation.navigate("ReconDetails", {
            item,
          });
        }
      }}
    >
      <View style={styles.headerContent}>
        <View>
          <Text variant="title_16" style={{ color: color.mediumBlack }}>
            {item?.db_name}
          </Text>
          <View style={styles.subtitleContainer}>
            {subTitle({
              subtitle: "Cash Short :",
              value: `₹${item?.cash_short}`,
            })}
            {subTitle({
              subtitle: "Lost/Damage :",
              value: item?.item_short,
            })}
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default ReconListTile;

const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    padding: 16,
    paddingVertical: 12,
    margin: 16,
    marginVertical: 8,
    backgroundColor: "white",
  },
  captionValueContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  subtitle: {
    color: color.black06,
    marginRight: 2,
    lineHeight: 18,
  },
  value: {
    color: color.mediumBlack,
    fontWeight: "bold",
  },
  headerContent: {
    flex: 1,
  },
  subtitleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 4,
  },
});
